import { jsx as _jsx } from "react/jsx-runtime";
/** 1px-gap grid of KPI cells; 2-up on mobile (README). `square` paints equal tiles. */
export function KpiStrip({ children, columns = 4, square }) {
    if (square) {
        return _jsx("section", { "data-kpi-grid": true, className: "tl-kpi-tiles", children: children });
    }
    return _jsx("section", { "data-kpi-grid": true, style: { display: 'grid', gridTemplateColumns: `repeat(${columns}, minmax(0,1fr))`, gap: 1, background: 'var(--border)', border: '1px solid var(--border)', borderRadius: 4, overflow: 'hidden' }, children: children });
}
//# sourceMappingURL=KpiStrip.js.map